//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Map from "./map.vue";
import { Cascader, Popup, Field, Switch, Toast } from 'vant';
import { getJson , getGeoData, addAddress, getAddressById ,getLocationByCode, getLocalCode, getGeoThreeData, getGeoFourData,getDetailsAddress} from '@/api/address'
import { getCookie } from "@/utils/auth.js";
export default {
  data () {
    return {
      cascaderValue: "",
       show: false,
       fieldNames: {
        text: 'name',
        value: 'code',
        children: 'children',
      },
      options: [
        // {
        //   name: '浙江省',
        //   code: '330000',
        //   items: [{ name: '杭州市', code: '330100' }],
        // },
        // {
        //   name: '江苏省',
        //   code: '320000',
        //   items: [{ name: '南京市', code: '320100' }],
        // },
      ],
      isChange: false,
      isDefault: 0, //默认开关
      tagList: [{name:'家',check:true},{name:'公司',check:false},{name:'送礼',check:false},{name:'领导',check:false},{name:'女友',check:false},{name:'闺蜜',check:false}],
      receiver: "",//收货人
      addr: "",    //详细地址
      houseNumber:"",//门牌号
      mobile: "",//联系电话
      provinceId: "",
      province: "",//省
      city: "",//市
      cityId:"",
      districtId:'',
      district: '',//区
      town:"",//街道
      townId:"",
      tagName: "家",//标签名称
      uaId: "",
      opt: "",
      showMap: false,
      iframeUrl: '',
      isSubmit: true,
      goodsType:0,//默认0  1  返回有经纬度的地址   0   返回所有地址
      fromType:"",//来源路径
      tblId:'',//运费模板id
      fromUrl:'',//
      };
  },

  components: {
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Switch.name]: Switch,
    [Toast.name]: Toast,
    Map
  },

  computed: {},

  created(){
    console.log("进入地址页面------------")
    this.getJson()
    if(this.$route.query.source){
      this.opt = this.$route.query.source;
    }
    if(this.opt == "edit"){
      document.title = "编辑地址";
    }
    console.log("this.$route.query.uaId-------",this.$route.query.uaId)
    if(this.$route.query.uaId){
      this.uaId = this.$route.query.uaId
      this.getAddressById()
    }
    if(this.$route.query.goodsType){
      this.goodsType = this.$route.query.goodsType
    }
    if(this.$route.query.type){
      this.fromType = this.$route.query.type
    }
    if(this.$route.query.tblId){
      this.tblId = this.$route.query.tblId
    }
    if(this.$route.query.url){
      this.fromUrl = this.$route.query.url
    }

  },

  mounted(){
    const that = this;
    let hasClick = false;
  },

  methods: {
    getAddressInfo(data){
      console.log(data)
      this.addr = data.name;
      this.latitude = data.location.lat;
      this.longitude = data.location.lng;
      this.getLocal(data.location.lat, data.location.lng);
      console.log("获取数据数据------",data)
      this.showMap = false;
    },
    open() {
      this.show = true
    },

    openTowns() {

    },
    openLoaction(){
      // 跳转之前要保存已写数据到vuex里面
      this.showMap = true;
      // let params = {
      //   mobile: this.mobile,
      //   addr: this.addr,
      //   receiver: this.receiver,
      //   isDefault: this.isDefault,
      //   tagName: this.tagName,

      // }
      // this.$store.commit('updateForm',Object.assign({},params))
      // this.$router.push({
      //   path: '/mapLocation'
      // })
    },
     // 获取当前地理位置
    getLocal: function(latitude, longitude) {
      let that = this;
      let str = latitude + ',' + longitude
      let params = {
        latitude: latitude,
        longitude:longitude
      }
      getDetailsAddress(params).then(res=> {
        if(res.code == 200){
           let addressCom = res.data;
           console.log(res.data)
            that.getLocalCode(addressCom.province, addressCom.city, addressCom.district, addressCom.township, addressCom.number)
        }
      })
  },
  getLocalCode(province,city,district,street,streetNumber){
    let params = {
      province: province,
      city: city,
      district: district,
      street: street,
      streetNumber: streetNumber
    }
    console.log("请求数据--------",params)
    getLocalCode(params).then(res=> {
      if(res.code == 200){
        let data = res.data;
        console.log("显示街道1--------",data)
        if(data.townId && data.town){
          this.cascaderValue = data.townId
          this.province = data.province
          this.provinceId = data.provinceId
          this.city = data.city
          this.cityId = data.cityId
          this.district = data.district
          this.districtId = data.districtId
          this.town = data.town
          this.townId = data.townId;
          console.log("显示街道2--------",data.town)
          this.getGeoFourData(data.districtId)
        }else{
          this.cascaderValue = data.townId
          this.province = data.province
          this.provinceId = data.provinceId
          this.city = data.city
          this.cityId = data.cityId
          this.district = data.district
          this.districtId = data.districtId
          // this.town = data.town
          // this.townId = data.townId
          this.getGeoFourData(data.districtId,'add')
        }

      }else{
        Toast(res.msg);
      }
    })
  },
    //选择标签
    tagCheck(item) {
      this.tagList.map(item1=> {
        item1.check = false
      })
      item.check = true
      this.tagName = item.name
    },
    //开关选择
    changeSwitch(val) {
      console.log(val,'val')
    },
    //设为默认地址
    changeDefault(){
      this.isDefault = !this.isDefault;
    },
    //保存地址
    saveForm(){
      if(this.receiver ==""){
        Toast('请输入收货人！')
        return
      }
      if(this.mobile =="" || this.mobile.length != 11){
        Toast('请输入正确的联系方式！')
        return
      }
      if(this.province ==""){
        Toast('请选择所在地区！')
        return
      }
      if(this.addr ==""){
        Toast('请输入详细地址！')
        return
      }
      if(this.houseNumber ==""){
        Toast('请输入门牌号！')
        return
      }

      let uid = getCookie("hdu");
      let params = {
        uid: uid,
          // thirdsession: getApp().globalData.thirdSession,
        name: this.tagName,
        receiver: this.receiver,
        mobile: this.mobile,
        addr: this.addr,
        houseNumber:this.houseNumber,
        provinceId: this.provinceId,
        cityId: this.cityId,
        districtId: this.districtId,
        provice: this.province,
        city: this.city,
        district: this.district,
        townId:this.townId,
        town: this.town,
        isDefault : this.isDefault? 1:0,
        uaId: this.opt == 'edit'? this.uaId : '',
        latitude: this.latitude,
        longitude: this.longitude
      }
      console.log("保存数据------",params)
      //提交中
      this.isSubmit = false
      addAddress(params).then(res=> {
        if(res.code == 200){
           Toast('保存成功！')
           //从订单列表修改地址过来的，回到订单地址修改列表去
          if(this.fromType == "updateOrderList"){
            window.location.href = this.fromUrl;
          }else{
            this.$router.push({
              path: '/addressList',
              query: {
                goodsType:this.goodsType,
                type:this.fromType,
                tblId:this.tblId,
                url:this.fromUrl
              }
            })
          }

        }else{
          Toast(res.msg)
          this.isSubmit= true
        }
      })
    },
    //获取地址详情
    getAddressById() {
      let params= {
        uaid: this.uaId
      }
      getAddressById(params).then(res=>{
        if(res.code == 200){
          let data = res.data;
          this.mobile = data.mobile
          this.receiver = data.receiver
          this.cascaderValue = data.townId
          this.province = data.provice
          this.provinceId = data.provinceId
          this.city = data.city
          this.cityId = data.cityId
          this.district= data.district
          this.districtId = data.districtId
          this.town = data.town
          this.townId = data.townId
          this.addr = data.addr;
          this.houseNumber = data.houseNumber;
          this.tagName = data.name;
          this.latitude = data.latitude;
          this.longitude = data.longitude
          this.tagList.map(item=>{
            item.check = false
            if(item.name == data.name){
              item.check = true
            }
          })
          this.isDefault = data.isDefault==1? true: false
          this.getGeoFourData(data.districtId)
        }
      })
    },
    //获取三级地址
    getJson(){
      getGeoThreeData().then(res=> {
       console.log(res)
        this.options = res.data
      })
    },
    //获取四级地址
    async getGeoFourData(code,type){
      let params = {
        threeCode: code
      }
      await getGeoThreeData().then(res=> {
       console.log(res)
        this.options = res.data
      })


      await getGeoFourData(params).then(res=> {
        // console.log(this.options,'item2')
        this.options.map(item=> {
          if(item.code == this.provinceId){
            item.children.map(item1=> {
              if(item1.code == this.cityId){
                item1.children.map(item2=> {
                  if(item2.code == this.districtId){
                    item2.children = []
                    item2.children = res.data
                    if(type == 'add'){
                      this.town = res.data[0].name
                      this.townId = res.data[0].code
                      this.cascaderValue = res.data[0].code
                    }
                  }
                })
              }
            })
          }
        })
      })
    },
    onFinish({ selectedOptions }) {
      this.province = selectedOptions[0].name
      this.provinceId = selectedOptions[0].code
      this.city = selectedOptions[1].name
      this.cityId = selectedOptions[1].code
      this.district = selectedOptions[2].name
      this.districtId = selectedOptions[2].code
      if(selectedOptions.length==4){
        this.town = selectedOptions[3].name
        this.townId = selectedOptions[3].code
        this.show = false
      }

      // console.log(selectedOptions,'selectedOptions')

    },
    onChange(val) {
      if(val.tabIndex == 2){
        let code = val.selectedOptions[2].code
        this.getGeoFourData(code,'add')
      }
      console.log(val,'1111')
      // console.log(this.cascaderValue,'cascaderValue')
    }
  }
}




// WEBPACK FOOTER //
// ./src/view/address/newAddress.vue